module.exports = __webpack_public_path__ + "img/189.adf1b319.png";